import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  signal,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLabelPipe } from 'src/app/core/pipes/translate-label.pipe';
import { FilterConfig, FiltersService } from './filters.service';
import { NavService } from '../core/providers/services/nav.service';
import { DynamicContainerDirective } from './filter-types/directives/dynamic-container.directive';
import { AbstractControl, FormControl } from '@angular/forms';
import { FormSelect, InputOption } from './filter-types/types';
import { Subscription } from 'rxjs';

export const getFilterName = (url: string): string | undefined => {
  const str = url[0] === '/' ? url.substring(1) : url;
  return str.split('/').pop();
};

@Component({
  selector: 'app-filter',
  template: `
    <div [attr.data-comp]="'Filter'" class="content content-md">
      <form
        [formGroup]="filtersService.form"
        [attr.data-value]="currentValue()"
      >
        <div class="scroll-content scroll-content--no-search">
          <ng-template id="DynamicContainer" appDynamicContainer></ng-template>
        </div>
      </form>
    </div>
  `,
  providers: [TranslateLabelPipe],
  standalone: false,
})
export class FilterComponent implements OnInit, OnDestroy {
  @ViewChild(DynamicContainerDirective, { static: true })
  dynamicHost!: DynamicContainerDirective;
  public currentValue: WritableSignal<string | number | null> = signal(null);
  private changeSubscription: Subscription | null = null;

  public filterName: string | undefined;
  public filter: FilterConfig | null = null;
  private formControl: AbstractControl<any, any> | null = null;
  constructor(
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    public filtersService: FiltersService,
    private navService: NavService
  ) {}

  ngOnInit() {
    //setTimeout(() => {
    this.navService.pageTitle = this.translateService.instant(
      `main.filters.mobile.rate.use-rented-as-product-type.button`
    );
    this.navService.showBackButton = true;
    this.navService.showFilters = false;
    this.navService.showSearchbar = false;
    // }, 0);

    this.filterName = getFilterName(this.router.url);
    if (this.filterName) {
      try {
        this.filter = this.filtersService.getFilter(this.filterName);
        this.navService.pageTitle = this.translateService.instant(
          this.filter.localization.button
        );

        this.formControl = this.filtersService.addField(this.filterName);

        if (!this.formControl) {
          throw new Error(
            `No form control could be found for ${this.filterName}`
          );
        }

        this.changeSubscription = this.formControl.valueChanges.subscribe(
          (val) => {
            this.currentValue.set(this.getFilterValue());
          }
        );

        this.loadComponent();
      } catch (error) {
        console.error(error);
      }
    } else {
      throw new Error(`No filter could be found: ${this.filterName}`);
    }
  }

  ngOnDestroy() {
    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
    }
  }

  // TODO: This will have to be updated when other filter types are added.
  public getFilterValue(): string | number {
    let result;
    if (this.filterName) {
      const control = this.filtersService.form.controls[this.filterName];
      result = control.value;
    }
    if (result === null) {
      result = 'null';
    } else if (typeof result === 'boolean') {
      result = result.toString();
    }
    return result;
  }

  private loadComponent() {
    const viewContainerRef: ViewContainerRef =
      this.dynamicHost.viewContainerRef;
    viewContainerRef.clear(); // Clear previous components
    const ref = viewContainerRef.createComponent(this.filter?.component);
    const instance = ref.instance as Partial<FormSelect<any>>;
    instance.name = <string>this.filter?.CodeName;
    if (this.formControl) {
      instance.control = this.formControl as FormControl;
    }
    if (this.filter?.options) {
      instance.options = <InputOption<any>[]>this.filter?.options;
    }
    this.currentValue.set(this.getFilterValue());
  }
}
